import { Base } from "./base";

export class User extends Base {
  /**
   * @description List Sublocation API function
   * @param {object} filterParams
   * @param {?string} filterParams.location Location ID associated with the sublocation
   * @returns {Promise<Response>}
   */
  list() {
    const url = new URL(this._getFullURL("/users"));
    return fetch(url, this._generateRequestBody({}));
  }

  /**
   * @description Create Sublocation API function
   * @param {object} payload
   * @returns {Promise<Response>}
   */
  create(payload) {
    const url = this._getFullURL("/users");
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }
  /**
   * @description Create User Logs API function
   * @param {object} payload
   * @returns {Promise<Response>}
   */
  createUserLogs(payload) {
    const url = this._getFullURL("/users/logs");
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }

  update(uid, payload) {
    const url = this._getFullURL("/users/" + uid);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "PUT",
      })
    );
  }

  delete = (uid) => {
    const url = this._getFullURL(`/users/${uid}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: null,
        method: "DELETE",
      })
    );
  };

  me() {
    const url = new URL(this._getFullURL("/users/me"));
    return fetch(url, this._generateRequestBody({}));
  }

  updateMe(payload) {
    const url = this._getFullURL("/users/me");
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "PUT",
      })
    );
  }
  addSetupDone(payload) {
    const url = this._getFullURL("/users/me-add-setup");
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "PUT",
      })
    );
  }

  forgotPassword(email) {
    const url = this._getFullURL("/user/password_reset/");
    const payload = {
      email,
    };

    return fetch(
      url,
      this._generateRequestBody({
        authentication: false,
        payload,
        method: "POST",
      })
    );
  }

  resetPassword(token, password) {
    const url = this._getFullURL("/user/password_reset/confirm/");
    const payload = {
      token,
      password,
    };

    return fetch(
      url,
      this._generateRequestBody({
        authentication: false,
        payload,
        method: "POST",
      })
    );
  }
}
